import React, { useState } from 'react';
import Card from 'react-bootstrap/Card';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { Container } from 'react-bootstrap';
import pdfFile1 from "../../public//Files//career/Emp of Irri Engr & Hydrologist.pdf";
import pdfFile2 from "../../public//Files//career//Hydroligist.pdf";
import pdfFile3 from "../../public//Files//career//Automation Engineer.pdf";
import pdfFile4 from "../../public//Files//career//Job_Opportunity-CFO-LIMS.pdf";
import lims_logo from "../../public/media/combined_images/logo.png"


function truncateText(text, limit) {
  const words = text.split(' ');
  if (words.length > limit) {
    return words.slice(0, limit).join(' ') + '...';
  }
  return text;
}

function Career() {
  const [showModal, setShowModal] = useState(false);
  const [modalPdfUrl, setModalPdfUrl] = useState('');

  const cardData = [
    {
      title: 'JOB OPPORTUNITIES = Irrigation Engineer – Design Section',
      text: 'Publishing Date: 2024-04-25',
      text1: 'Closing Date: 2024-05-09',
      buttonText: 'Preview',
      logo1: lims_logo,
      logo2: lims_logo,
      modalPdfUrl: pdfFile1 // Replace with the PDF file URL for this card
    },
    {
      title: 'JOB OPPORTUNITIES = Hydrologist',
      text: 'Publishing Date: 2024-04-25',
      text1: 'Closing Date: 2024-05-09',
      buttonText: 'Preview',
    logo1: lims_logo,
      logo2: lims_logo,
      modalPdfUrl: pdfFile2 // Replace with the PDF file URL for this card
    },
    {
      title: 'CAREER OPPORTUNITY as Automation Engineer',
      text: 'Publishing Date: 2024-04-17',
      text1: 'Closing Date: 2024-05-09',
      buttonText: 'Preview',
       logo1: lims_logo,
      logo2: lims_logo,
      modalPdfUrl: pdfFile3// Replace with the PDF file URL for this card
    },

      {
      title: 'CAREER OPPORTUNITY as Chief Financial Officer (CFO)',
      text: 'Publishing Date: 2024-10-03',
      text1: 'Closing Date: 2024-10-19',
      buttonText: 'Preview',
        logo1: lims_logo,
      logo2: lims_logo,
      modalPdfUrl: pdfFile4// Replace with the PDF file URL for this card
    },

  ];

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleShowModal = (modalPdfUrl) => {
    setModalPdfUrl(modalPdfUrl);
    setShowModal(true);
  };

  return (
    <Container>
       <style>
      {`
        @keyframes floatLogo {
          0% { transform: translateY(0px) scale(1); }
          50% { transform: translateY(-8px) scale(1.03); }
          100% { transform: translateY(0px) scale(1); }
        }
      `}
    </style>
      <Row xs={1} md={3} className="g-4" style={{ marginTop: "20px" }}>
        {cardData.map((card, idx) => (
          <Col key={idx} xs={12} sm={6} md={4}>
            <Card style={{ background: "#F5F7FB", borderRadius: "25px", fontFamily: 'Poppins, sans-serif', fontSize: '14px',height:"390px" }}>
              <Card.Body>
                <Card.Title style={{ fontSize: '16px', marginBottom: '10px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{truncateText(card.title, 5)}</Card.Title>
                <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
                  <img src={card.logo1} alt="Logo" style={{  width: "30px",
                    height: "30px",
                    objectFit: "contain",
                    marginRight: "10px", }} />
                  <span>{card.text}</span>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', marginBottom: '50px' }}>
                  <img src={card.logo2} alt="Logo" style={{  width: "30px",
                    height: "30px",
                    objectFit: "contain",
                    marginRight: "10px",
                    }} />
                  <span>{card.text1}</span>
                </div>
              <hr style={{ margin: "0px 0 15px 0" }} />
                 <div
                style={{
                  flex: 1,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <img
                  src={card.logo1}
                  alt="Centered Animated Logo"
                  style={{
                    width: "120px",
                    height: "120px",
                    objectFit: "contain",
                    opacity: 0.85,
                    animation: "floatLogo 3s ease-in-out infinite",
                    filter: "drop-shadow(0px 8px 12px rgba(0, 0, 0, 0.08))",
                  }}
                />
              </div>
              </Card.Body>
              <Card.Footer className="text-center" style={{ background: "#0e97ff", borderRadius: "17px", padding: "10px 20px",display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                <Button onClick={() => handleShowModal(card.modalPdfUrl)} style={{ borderRadius: "8px", width: "150px", background: "#e5e8ef", border: "1px solid #dfe2e", color: "black" }}>{card.buttonText}</Button>
                <a href={card.modalPdfUrl} download="Job_details.pdf">
                   <img
                  src="https://cdn-icons-png.flaticon.com/128/15525/15525195.png"
                  alt="Download"
                  style={{
                    height: "50px",
                    width: "auto",
                    marginLeft: "10px",
                  }}
                />
                </a>
              </Card.Footer>
            </Card>
          </Col>
        ))}
      </Row>
      <Modal show={showModal} onHide={handleCloseModal} centered size="lg">
        <Modal.Header closeButton>
          {/* <Modal.Title>Modal Title</Modal.Title> */}
        </Modal.Header>
        <Modal.Body>
          <iframe title="_modal_url_" src={modalPdfUrl} style={{ width: '100%', height: '400px', border: 'none' }}></iframe>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
}

export default Career;
